import { httpClient } from './httpClient'

export async function getDoctorData () {
  try {
    const response = await httpClient({
      baseURL: import.meta.env.VITE_API_MAIN_BASEURL,
      url: import.meta.env.VITE_USER_DATA_ENDPOINT,
      withCredentials: true,
      method: 'GET',
      cache: false
    })

    return response?.data
  } catch (error) {
    console.log(error)
    console.error('getDoctorData - Error: ', error)
    throw error
  }
}

export async function connectStripe () {
  try {
    const response = await httpClient({
      baseURL: import.meta.env.VITE_API_MAIN_BASEURL,
      url: '/Stripe/ConnectStripe',
      withCredentials: true,
      method: 'POST',
      cache: false
    })

    return response?.data
  } catch (error) {
    console.log(error)
    console.error('connectStripe - Error: ', error)
    throw error
  }
}

export async function getDoctorSettings () {
  try {
    const response = await httpClient({
      baseURL: import.meta.env.VITE_API_MAIN_BASEURL,
      url: import.meta.env.VITE_USER_SETTINGS_ENDPOINT,
      withCredentials: true,
      method: 'GET',
      cache: false
    })

    return response?.data
  } catch (error) {
    console.error('getDoctorSettings - Error: ', error)
    throw error
  }
}

export async function getDoctorPatients () {
  try {
    const response = await httpClient({
      baseURL: import.meta.env.VITE_API_MAIN_BASEURL,
      url: import.meta.env.VITE_DOCTOR_PATIENTS_ENDPOINT,
      withCredentials: true,
      method: 'GET',
      cache: false
    })

    return response?.data
  } catch (error) {
    console.error('getDoctorPatients - Error: ', error)
    throw error
  }
}

export async function getDoctorPatient ({ patientId }: { patientId: number }) {
  let url = import.meta.env.VITE_DOCTOR_PATIENT_ENDPOINT
  url = url.replace('__patientId__', patientId)
  try {
    const response = await httpClient({
      baseURL: import.meta.env.VITE_API_MAIN_BASEURL,
      url,
      withCredentials: true,
      method: 'GET',
      cache: false
    })

    return response?.data
  } catch (error) {
    console.error('getDoctorPatients - Error: ', error)
    throw error
  }
}

export async function sendInvitation ({ patientId }: { patientId: number }) {
  let url = import.meta.env.VITE_DOCTOR_SEND_INVITATION_ENDPOINT
  url = url.replace('__patientId__', patientId)

  try {
    const response = await httpClient({
      baseURL: import.meta.env.VITE_API_MAIN_BASEURL,
      url,
      withCredentials: true,
      method: 'POST',
      data: {
        patientId
      }
    })

    return response
  } catch (error) {
    console.error('sendInvitation - Error: ', error)
    throw error
  }
}
